import Handlebars from 'handlebars'
import GlobalProps from './global-props'
import some from 'lodash/some'
import toggleIsOn from './helpers/toggle-helper'

Handlebars.registerHelper('editable', value => {
  const fnTrue = value.fn
  const fnFalse = value.inverse

  return GlobalProps.editable ? fnTrue(this) : fnFalse(this)
})

Handlebars.registerHelper('isOn', (prop, value) => {
  const fnTrue = value.fn
  const fnFalse = value.inverse

  return toggleIsOn(value.data.root, prop) ? fnTrue(value.data.root) : fnFalse(value.data.root)
})

// opposite of isOn
Handlebars.registerHelper('isOff', (prop, value) => {
  const fnTrue = value.fn
  const fnFalse = value.inverse

  return toggleIsOn(value.data.root, prop) ? fnFalse(value.data.root) : fnTrue(value.data.root)
})

Handlebars.registerHelper('hasField', (prop, value) => {
  const toggle = value.data.root._toggle

  const fnTrue = value.fn
  const fnFalse = value.inverse

  return !toggle || some(prop.split(' '), field => toggle[field] !== false)
    ? fnTrue(value.data.root)
    : fnFalse(value.data.root)
})
